import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import en from "i18n/en.json";
import ru from "i18n/ru.json";
import { IntlProvider } from "react-intl";
import ReactGA from "react-ga4";
import { env } from "config";
import { isChargebee } from "services/payment/paymentProvider";

import { YMInitializer } from "react-yandex-metrika";
import { ConfigProvider } from "antd";
import ruRU from "antd/lib/locale/ru_RU";
import moment from "moment";
import "moment/locale/ru";

import { isRu } from "services/region/region";
import { CookieNotice } from "components/cookie-notice/CookieNotice";

import "./index.css";

// Foreign trackers are forbidden on the ru instance (RKN); Yandex Metrika stays everywhere.
if (!isRu()) {
  ReactGA.initialize(env.REACT_APP_GA_ID);

  const hubspot = document.createElement("script");
  hubspot.type = "text/javascript";
  hubspot.id = "hs-script-loader";
  hubspot.async = true;
  hubspot.defer = true;
  hubspot.src = "//js-eu1.hs-scripts.com/27022186.js";
  document.head.appendChild(hubspot);
}

if (isChargebee()) {
  // Chargebee.js is loaded only when Chargebee is the active provider;
  // in YooKassa mode the checkout is a plain redirect to a payment link
  const chargebeeScript = document.createElement("script");
  chargebeeScript.src = "https://js.chargebee.com/v2/chargebee.js";
  chargebeeScript.onload = () => {
    // @ts-ignore
    window.Chargebee.init({
      site: env.REACT_APP_CHARGE_BEE_SITE
    });
  };
  document.head.appendChild(chargebeeScript);
}

const ymId = Number(env.REACT_APP_YM_ID);

const locale = isRu() ? "ru" : "en";
const messages = isRu() ? ru : en;
// importing moment/locale/ru switches the global moment locale, so set it back explicitly
moment.locale(locale);

if (isRu()) {
  document.documentElement.lang = "ru";
  document.title = "Магазин Джеймикс";
}

const intlApp = (
  <IntlProvider
    messages={messages}
    locale={locale}
    defaultLocale="en"
  >
    <CookieNotice />
    <App />
  </IntlProvider>
);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <YMInitializer accounts={[ymId]}/>
      {isRu() ? <ConfigProvider locale={ruRU}>{intlApp}</ConfigProvider> : intlApp}
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);
